<template>
  <i18n-t
    tag="p"
    keypath="Expand your search by {removeAccommodationTypes} filter."
  >
    <template #removeAccommodationTypes>
      <pu-low-results-search-link
        :modify-filters="{ categoryIds: [] }"
        category="campsites"
        exclude-type="type"
      >
        <translate>removing the accommodation types</translate>
      </pu-low-results-search-link>
    </template>
  </i18n-t>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class LowResultsCategories extends Vue {}

export default toNative(LowResultsCategories)
</script>
